import { render, staticRenderFns } from "./Benutzerliste.vue?vue&type=template&id=50d59668"
import script from "./Benutzerliste.vue?vue&type=script&lang=js"
export * from "./Benutzerliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports